import { useContext } from "react";
import { ComponentAdditionPageContext, PageNewState } from "./";

export const usePageState = () => {
  const { pageState, setPageState } = useContext(ComponentAdditionPageContext);
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
